import React from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import type { WithFlagsProps } from '@confluence/flags';
import { withFlags } from '@confluence/flags';

import type { EditorPageCoverPictureComponentProps } from '../pageCoverPictureTypes';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Placeholder = styled.div<{
	dynamicCoverImageHeight?: number;
}>({
	position: 'relative',
	background: token('color.background.accent.gray.subtlest'),
	borderRadius: '3px',
	width: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	height: (props) => `${props.dynamicCoverImageHeight}px`,
});

export const EditorPageCoverPicturePlaceholder = withFlags(
	(props: EditorPageCoverPictureComponentProps & WithFlagsProps) => {
		return props.hasCoverPicture ? <Placeholder /> : null;
	},
);
